import { Address, defaultAddress } from '../contacts/address';
import { PhoneNumber, defaultPhoneNumber } from '../contacts/phoneNumber';
import { ResponseBase } from '../Base';
import { ConnectAdjusterFees } from '../financials/ConnectAdjusterFees';

export interface User {
    userId: number; 
    roles: string[]; 
    permissions: string[]; 
    isActive: boolean; 
    lastActivityDate?: string; 
}

export interface Contact {
    contactId: number;
    isActive: boolean;  
    firstName: string;
    lastName: string;
    middleName: string; 
    preferredName: string;
    fullName: string;
    email: string; 
    compassEmail: string; 
    phoneNumbers: PhoneNumber[]; 
    xnAddress: string;
    xnAddress2: string;    
    companyName: string; 
    title: string; 
    contactTypes: string[];     
    user?: User; 
    mailingAddress: Address;    
    adjusterPercents?: ConnectAdjusterFees; 
    connectAdminId?: number, 
    connectAdjusterId?: number, 
    syncDate?: string,
    connectObjDate?: string,
    connectObj?: string,
    syncStatus?: string, 
    syncError?: string,
    totalClaims?: number;
    activeClaims?: number;
}

export interface ContactsResponse extends ResponseBase<Contact> { }

export const defaultContact: Contact = {
    contactId: 0,
    isActive: true, 
    firstName: '',
    lastName: '',
    middleName: '',
    preferredName: '',
    fullName: '',
    email: '',
    compassEmail: '', 
    phoneNumbers: [defaultPhoneNumber],
    xnAddress: '',
    xnAddress2: '', 
    companyName: '',
    title: '',
    contactTypes: [],
    mailingAddress: defaultAddress, 
}

export interface ContactDuplicate {
    contactId: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: string;
    matchScore: number;
    matchReason: string; // e.g., "Exact Email Match", "Name/Phone Similarity"
    isActive: boolean;
    claimCount: number;
    activeClaims: number;
    connectAdminId?: number;
    connectAdjusterId?: number;
}

export interface ConctactDupeResponse extends ResponseBase<ContactDuplicate>{}
